import { makeSelectFieldOptionsFromEnum } from 'Common/FormHelper';

export const ExportFieldsEnum = {
  Balance: 1,
  Status: 2,
  Both: 3,
};

export const ExportFieldsOptions = makeSelectFieldOptionsFromEnum(
  ExportFieldsEnum
);



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/powerschoolexport/helpers/PowerSchoolExportHelpers.js